// Destination mode for /s3/upload-complete; drives backend folder resolution
// and duplicate/reupload validation.
export enum UploadDestination {
  /** Folder validation and related checks; does not create the folder. */
  NEW = 'new',
  /** Existing currentFolderId; server rejects duplicate file names. */
  EXISTING = 'existing',
  /** Replaces the dataset in currentFolderId; geometry-validated, no dup check. */
  REUPLOAD = 'reupload',
}
